import React from 'react';
import ReputationBadgeLayout from './Layout';
const ReputationBadge = ({ badge }) => {
    return (React.createElement(ReputationBadgeLayout, { rank: badge.rank, title: badge.title, count: badge.count, description: `Received this one for ${badge.condition.for}` }));
};
export default ReputationBadge;
